/**
 * This is the base iso date format for date-fns functions.
 * */
export const ISO_DATE_FORMAT = `yyyy-MM-dd'T'HH:mm:ss.SSSXXX`;
